module.exports = __webpack_public_path__ + "img/img-zhilian-s4-tuya.1738e5b4.jpg";